import styled from "styled-components"

// Responsive page scaffolding shared by pages that sit beside the fixed
// sidenav (64px collapsed / 240px expanded). Desktop pages keep the wider
// visual breathing room used by the original designs. On phones the sidenav
// overlays when expanded, so content only clears the real 64px rail and uses
// its own compact gutter.

export const PageOffset = styled.div`
  box-sizing: border-box;
  width: 100%;
  min-width: 0;
  overflow-x: hidden;
  padding-left: ${p => (p.isExpanded ? "240px" : "100px")};

  @media (max-width: 700px) {
    padding-left: 64px;
  }
`

export const ContentColumn = styled.div`
  box-sizing: border-box;
  width: 100%;
  min-width: 0;
  max-width: ${p => p.maxWidth || 940}px;
  margin: 0 auto;
`

export const PageBlock = styled.div`
  margin: 24px 30px;
  min-width: 0;

  @media (max-width: 900px) {
    margin: 16px 12px;
  }

  @media (max-width: 360px) {
    margin-left: 8px;
    margin-right: 8px;
  }
`
